import { makeArrayFromTo } from '@pbk/utils';
const createPageRange = (firstPage, lastPage) => {
    return makeArrayFromTo(firstPage, lastPage).map((page) => ({
        type: 'page',
        page,
    }));
};
const BOUNDARY_PAGES = 2;
const SIBLING_PAGES = 1;
const MAX_SHOWN_PAGES = BOUNDARY_PAGES * 2 + SIBLING_PAGES * 2 + 1;
const FIRST_PAGE = 0;
export const calculatePageDefinitions = ({ totalPageCount, currentPage, }) => {
    const lastPage = totalPageCount - 1;
    if (totalPageCount < MAX_SHOWN_PAGES) {
        return createPageRange(FIRST_PAGE, lastPage);
    }
    const startBoundaryEnd = Math.min(FIRST_PAGE + BOUNDARY_PAGES - 1, totalPageCount);
    const endBoundaryStart = Math.max(lastPage - BOUNDARY_PAGES + 1, startBoundaryEnd);
    const minSiblingStart = startBoundaryEnd + 1;
    const maxSiblingStart = endBoundaryStart - SIBLING_PAGES * 2 - 1;
    const siblingsStart = Math.max(Math.min(currentPage - SIBLING_PAGES, maxSiblingStart), minSiblingStart);
    const minSiblingEnd = startBoundaryEnd + SIBLING_PAGES * 2 + 1;
    const maxSiblingEnd = endBoundaryStart - 1;
    const siblingsEnd = Math.max(Math.min(currentPage + SIBLING_PAGES, maxSiblingEnd), minSiblingEnd);
    const showStartBoundaryPlaceholder = siblingsStart > minSiblingStart;
    const showEndBoundaryPlaceholder = siblingsEnd < maxSiblingEnd;
    return [
        ...createPageRange(FIRST_PAGE, startBoundaryEnd - 1),
        {
            type: showStartBoundaryPlaceholder ? 'placeholder' : 'page',
            page: startBoundaryEnd,
        },
        ...createPageRange(siblingsStart, siblingsEnd),
        {
            type: showEndBoundaryPlaceholder ? 'placeholder' : 'page',
            page: endBoundaryStart,
        },
        ...createPageRange(endBoundaryStart + 1, lastPage),
    ];
};
